import Analytics from '@withlocals/withlocals-analytics';
import addMonths from 'date-fns/addMonths';
import addYears from 'date-fns/addYears';
import isPast from 'date-fns/isPast';
import { isCordova } from 'utils/platform';

import { TriggeringEvent, UserFeedback } from '../types/RateApp';

interface Storage {
  setItem(id: string, value: string): void;
  getItem(id: string): string;
  removeItem(id: string): void;
}

export enum Keys {
  TRIGGERING_EVENT = 'AppRating.EVENT',
  USER_FEEDBACK = 'AppRating.FEEDBACK',
}

export default class RateAppManager {
  private storage: Storage | null;

  constructor(storage: Storage | null) {
    this.storage = storage;
  }

  shouldAppear() {
    try {
      const lastEvent = this.storage?.getItem(Keys.TRIGGERING_EVENT);
      if (
        isCordova() &&
        Object.values(TriggeringEvent).includes(lastEvent as TriggeringEvent)
      ) {
        const lastFeedback = this.storage?.getItem(Keys.USER_FEEDBACK);
        if (lastFeedback) {
          return isPast(parseInt(JSON.parse(lastFeedback).timeout, 10));
        }
        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  }

  trigger(event: TriggeringEvent) {
    try {
      this.storage?.setItem(Keys.TRIGGERING_EVENT, event);
    } catch (e) {}
  }

  update(feedback: UserFeedback) {
    const now = Date.now();

    let timeout;
    switch (feedback) {
      case UserFeedback.REJECTED:
        timeout = addYears(now, 10);
        break;
      case UserFeedback.POSTPONED:
        timeout = addMonths(now, 1);
        break;
      case UserFeedback.POSITIVE:
      case UserFeedback.NEGATIVE:
        timeout = addMonths(now, 6);
        break;
    }

    Analytics.track('App review', feedback, 'Review app banner', '');

    try {
      this.storage?.setItem(
        Keys.USER_FEEDBACK,
        JSON.stringify({
          feedback,
          date: now,
          timeout: timeout.getTime(),
        }),
      );

      this.storage?.removeItem(Keys.TRIGGERING_EVENT);
    } catch (e) {}
  }
}
